import React from 'react';
import NewsContainer from './NewsContainer';
import PopularContainer from './PopularContainer';

interface Props {}

const FinanceNews: React.FC<Props> = () => {
  return (
    <div className="md:flex md:space-x-4">
      <NewsContainer className="md:w-3/4 mt-6 h-11 relative" />
      <PopularContainer className="md:w-60 mt-6" />
    </div>
  );
};

export default FinanceNews;
